import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BuildingModel, BuildingModels } from 'src/app/models/building.model';
import { PartyModel } from 'src/app/models/party.model';
import { CodeDescriptionModel } from 'src/app/models/code-description.model';
import { Document } from 'src/app/models/document.model';
import { BuildingHutsIdResponseModel } from 'src/app/shared/building-search/models/buildingHutsId.response.model';
import { OwnerInformationModel } from '../../models/owner-information.model';

export class OccupantModel {
    isReoccupied: boolean = null;
    firstName: string = null;
    lastName: string = null;
    constructor(model?: Partial<OccupantModel>) {
        if (model && model !== undefined) {
            const def = new OccupantModel();
            Object.keys(def).forEach((key: string) => {
                this[key] = model[key] && model[key] !== undefined ?
                    model[key] : def[key];
            });
        }
    }
    static asForm(fb: FormBuilder): FormGroup {
        return fb.group({
            isReoccupied: [],
            firstName: [, Validators.required],
            lastName: [, Validators.required]
        });
    }
    static generateForm(fb: FormBuilder, model: OccupantModel): FormGroup {
        const form = OccupantModel.asForm(fb);
        form.setValue(model);
        return form;
    }
    static convertFormToModel(form: FormGroup): OccupantModel {
        return form.value;
    }
}
export class ApartmentOccupantsModel {
    //     apartmentId: string = null;
    apartmentNumber: number = null;
    occupants: OccupantModel[] = [];
    constructor(model?: Partial<ApartmentOccupantsModel>) {
        if (model && model !== undefined) {
            const def = new ApartmentOccupantsModel();
            Object.keys(def).forEach((key: string) => {
                if (key === 'occupants') {
                    this.occupants = model.occupants && model.occupants !== undefined ?
                        model.occupants.map(row => new OccupantModel(row)) :
                        def.occupants;
                } else {
                    this[key] = model[key] && model[key] !== undefined ?
                        model[key] : def[key];
                }
            });
        }
    }
    static buildApiList(list: ApartmentOccupantsModel[]): any[] {
        if (list === null || list === undefined) {
            return [];
        }
        const result = [];
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < list.length; i++) {
            if (list[i] !== null || list[i] !== undefined) {
                result.push(list[i]);
            }
        }
        return result;
    }
    static asForm(fb: FormBuilder): FormGroup {
        return fb.group({
            apartmentNumber: [, Validators.required],
            occupants: fb.array([])
        });
    }
    static generateForm(fb: FormBuilder): FormGroup {
        return fb.group({
            apartmentNumber: [, Validators.required],
            occupants: fb.array([])
        });
    }
    static convertFormToModel(form: FormGroup): ApartmentOccupantsModel {
        return form.value;
    }
}
export class JobDocumentsModel {
    ApplicationDetailDOB: Document[] = [];
    CertificateOccupancy: Document[] = [];
    ArchitectAffidavit: Document[] = [];
    JobFileDOB: Document[] = [];
    TaxAbatement: Document[] = [];

    constructor(model?: Partial<JobDocumentsModel>) {
        if (model && model !== undefined) {
            const def = new JobDocumentsModel();
            Object.keys(def).forEach((key: string) => {
                if (key === 'ApplicationDetailDOB') {
                    this.ApplicationDetailDOB = model.ApplicationDetailDOB && model.ApplicationDetailDOB !== undefined ?
                        model.ApplicationDetailDOB.map(row => new Document(row)) :
                        def.ApplicationDetailDOB;
                } else if (key === 'CertificateOccupancy') {
                    this.CertificateOccupancy = model.CertificateOccupancy && model.CertificateOccupancy !== undefined ?
                        model.CertificateOccupancy.map(row => new Document(row)) :
                        def.CertificateOccupancy;
                } else if (key === 'ArchitectAffidavit') {
                    this.ArchitectAffidavit = model.ArchitectAffidavit && model.ArchitectAffidavit !== undefined ?
                        model.ArchitectAffidavit.map(row => new Document(row)) :
                        def.ArchitectAffidavit;
                } else if (key === 'JobFileDOB') {
                    this.JobFileDOB = model.JobFileDOB && model.JobFileDOB !== undefined ?
                        model.JobFileDOB.map(row => new Document(row)) :
                        def.JobFileDOB;
                } else if (key === 'TaxAbatement') {
                    this.TaxAbatement = model.TaxAbatement &&
                        model.TaxAbatement !== undefined ?
                        model.TaxAbatement.map(row => new Document(row)) :
                        def.TaxAbatement;
                }
            });
        }
    }

    static asForm(fb: FormBuilder): FormGroup {
        return fb.group({
            apartmentNumber: [, Validators.required],
            CertificateOccupancy: fb.array([]),
            ArchitectAffidavit: fb.array([]),
            JobFileDOB: fb.array([]),
            TaxAbatement: fb.array([])
        });
    }

    static generateForm(fb: FormBuilder, model: JobDocumentsModel): FormGroup {
        const form = JobDocumentsModel.asForm(fb);
        form.setValue(model);
        return form;
    }

    static convertFormToModel(form: FormGroup): JobDocumentsModel {
        return form.value;
    }
}

export class JobDetailsModel {
    jobId: string = null;
    jobDocuments: JobDocumentsModel = null;
    constructor(model?: JobDetailsModel) {
        this.jobDocuments = new JobDocumentsModel();
        if (model && model !== undefined) {
            const def = new JobDetailsModel();
            Object.keys(def).forEach((key: string) => {
                this[key] = model[key] && model[key] !== undefined ?
                    model[key] : def[key];
            });
        }
    }
    static asForm(fb: FormBuilder): FormGroup {
        return fb.group({
            jobNumber: [, Validators.required],
            jobDocuments: JobDocumentsModel.asForm(fb)
        });
    }
    static generateForm(fb: FormBuilder, model: JobDetailsModel): FormGroup {
        const form = JobDetailsModel.asForm(fb);
        form.setValue(model);
        return form;
    }
    static convertFormToModel(form: FormGroup): JobDetailsModel {
        return form.value;
    }
}
export class SubRehababilitationModel {
    building: BuildingHutsIdResponseModel = null;
    searchType: string = null;
    isSelectRepresentative: boolean = null;
    representative: PartyModel = null;
    groundsForExemptions: CodeDescriptionModel[] = [];
    rehabilitaionStartDate: Date = null;
    rehabilitationCompletionDate: Date = null;
    rehabilitationReason: string = null;
    rehabAmount: number = null;
    ownerInformation: OwnerInformationModel[] = [];
    apartmentOccupants: ApartmentOccupantsModel[] = [];
    ownerBuildingAcquiredDate: Date = null;
    jobDetails: JobDetailsModel[] = [];
    incidentType: string = null;
    static requestApiMapper(model: SubRehababilitationModel): any {
        return {
            building: model ? model.building : '',
            searchType: model ? model.searchType : '',
            isSelectRepresentative: model ? model.isSelectRepresentative : '',
            representativeId: model ? model.representative ? model.representative.partyId ?
                model.representative.partyId : model.representative : '' : '',
            exemptions: model ? model.groundsForExemptions : '',
            rehabilitaionStartDate: model ? model.rehabilitaionStartDate : '',
            rehabilitationCompletionDate: model ? model.rehabilitationCompletionDate : '',
            rehabilitationReason: model ? model.rehabilitationReason : '',
            rehabAmount: model ? model.rehabAmount : '',
            ownerInformation: model ? model.ownerInformation : '',
            apartmentOccupants: model ? model.apartmentOccupants : '',
            jobDetails: model ? model.jobDetails : '',
            ownerBuildingAcquiredDate: model ? model.ownerBuildingAcquiredDate : '',
        };
    }
    static responseApiMapper(model: any, fb: FormBuilder): any {
        const documentRawValue = Document.asForm(fb).getRawValue();
        const apartmentOccupantRawValue = ApartmentOccupantsModel.asForm(fb).getRawValue();
        const jobDetailsRawValue = JobDetailsModel.asForm(fb).getRawValue();
        const ownerInformationRawValue = OwnerInformationModel.asForm(fb).getRawValue();
        const codeDescriptionRawValue = CodeDescriptionModel.asForm(fb).getRawValue();
        return {
            building: model ? model.building : '',
            searchType: model ? model.searchType : '',
            isSelectRepresentative: model ? model.isSelectRepresentative : '',
            representative: model ? model.representativeId : '',
            groundsForExemptions: model ? model.exemptions ? model.exemptions : codeDescriptionRawValue : codeDescriptionRawValue,
            rehabilitaionStartDate: model ? model.rehabilitaionStartDate : '',
            rehabilitationCompletionDate: model ? model.rehabilitationCompletionDate : '',
            rehabilitationReason: model ? model.rehabilitationReason : '',
            rehabAmount: model ? model.rehabAmount : '',
            ownerInformation: model ? model.ownerInformation : ownerInformationRawValue,
            apartmentOccupants: model ? model.apartmentOccupants.length > 0 ? model.apartmentOccupants : apartmentOccupantRawValue :
                apartmentOccupantRawValue,
            jobDetails: model ? model.jobDetails.length > 0 ? model.jobDetails : jobDetailsRawValue : jobDetailsRawValue,
            ownerBuildingAcquiredDate: model ? model.ownerBuildingAcquiredDate : ''
        };
    }
    static asForm(fb: FormBuilder): FormGroup {
        return fb.group({
            building: [, Validators.required],
            isSelectRepresentative: [, Validators.required],
            representative: [, Validators.required],
            groundsForExemptions: CodeDescriptionModel.asForm(fb),
            rehabilitaionStartDate: [, Validators.required],
            rehabilitationCompletionDate: [, Validators.required],
            rehabilitationReason: [, Validators.required],
            rehabAmount: [, Validators.required],
            ownerInformation: OwnerInformationModel.asForm(fb),
            apartmentOccupants: ApartmentOccupantsModel.asForm(fb),
            ownerBuildingAcquiredDate: [, Validators.required],
            jobDetails: JobDetailsModel.asForm(fb)
        });
    }
    static generateForm(fb: FormBuilder, model: SubRehababilitationModel): FormGroup {
        const form = SubRehababilitationModel.asForm(fb);
        form.setValue(model);
        return form;
    }
}
